
import { ECOMMARCEPLACES_REQUEST, ECOMMARCEPLACES_SUCCESS,ECOMMARCEPLACES_FAILURE, UPDATE_ECOMMARCEPLACES_REQUEST, UPDATE_ECOMMARCEPLACES_SUCCESS, UPDATE_ECOMMARCEPLACES_FAILURE } from './actionTypes';
import { ADD_MARKETPLACES_REQUEST, ADD_MARKETPLACES_SUCCESS, ADD_MARKETPLACES_FAILURE } from './actionTypes';
import ecommerceService from '../../services/ecommercePlaceService';
import { ECOMMARCEPLACES_ACCOUNT_REQUEST,ECOMMARCEPLACES_ACCOUNT_SUCCESS,ECOMMARCEPLACES_ACCOUNT_FAILURE } from './actionTypes';


export const ecommercePlaceRequest = () => ({
  type: ECOMMARCEPLACES_REQUEST,
});

export const ecommercePlaceSuccess = (user) => ({
  type: ECOMMARCEPLACES_SUCCESS,
  payload: user,
});

export const ecommercePlaceFailure = (error) => ({
  type:ECOMMARCEPLACES_FAILURE,
  payload: error,
});
export const getEcommercePlaces = (token) => {

  return async (dispatch) => {
    dispatch(ecommercePlaceRequest());
    try {

      const response = await ecommerceService.getEcommercePlaceApi(token);
      dispatch(ecommercePlaceSuccess(response.data));
      return response.data;
      
    } catch (error) {
      dispatch(ecommercePlaceFailure(error.response?.data || 'mağzalar bulunamadı!'));
      throw error;
    }
  };
};




export const addMarketPlacesRequest = () => ({
  type: ADD_MARKETPLACES_REQUEST,
});

export const addMarketPlacesSuccess = (user) => ({
  type: ADD_MARKETPLACES_SUCCESS,
  payload: user,
});

export const addMarketPlacesFailure = (error) => ({
  type: ADD_MARKETPLACES_FAILURE,
  payload: error,
});
export const addEcommercePlacesAccount = (data,token) => {

  return async (dispatch) => {
    dispatch(addMarketPlacesRequest());
    try {
      const response = await ecommerceService.addEcommercePlaceApi(data,token);
      dispatch(addMarketPlacesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addMarketPlacesFailure(error.response?.data || 'MAĞZA BİLGİLERİ EKLENEMEDİ!'));
      throw error;
    }
  };
  
};



export const ecommercePlacesAccountRequest = () => ({
  type: ECOMMARCEPLACES_ACCOUNT_REQUEST,
});

export const ecommercePlacesAccountSuccess = (user) => ({
  type: ECOMMARCEPLACES_ACCOUNT_SUCCESS,
  payload: user,
});

export const ecommercePlacesAccountFailure = (error) => ({
  type: ECOMMARCEPLACES_ACCOUNT_FAILURE,
  payload: error,
});
export const getEcommercePlacesAccounts = (id,token) => {

  return async (dispatch) => {
    dispatch(ecommercePlacesAccountRequest());
    try {
      const response = await ecommerceService.getEcommercePlaceAccountsApi(id,token);
      dispatch(ecommercePlacesAccountSuccess(response.data?.data));
      return response.data?.data;
    } catch (error) {
      dispatch(ecommercePlacesAccountFailure(error.response?.data || 'Mağza bilgileri bulunamadı!'));
      throw error;
    }
  };
  
};


export const updateEcommercePlacesRequest = () => ({
  type: UPDATE_ECOMMARCEPLACES_REQUEST,
});

export const updateEcommercePlacesSuccess = (user) => ({
  type: UPDATE_ECOMMARCEPLACES_SUCCESS,
  payload: user,
});

export const updateEcommercePlacesFailure = (error) => ({
  type: UPDATE_ECOMMARCEPLACES_FAILURE,
  payload: error,
});
export const updateEcommercePlacesAccount = (data,token) => {

  return async (dispatch) => {
    dispatch(updateEcommercePlacesRequest());
    try {
      const response = await ecommerceService.updateEcommercePlaceApi(data,token);
      dispatch(updateEcommercePlacesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(updateEcommercePlacesFailure(error.response?.data || 'MAĞZA BİLGİLERİ güncellenemedi!'));
      throw error;
    }
  };
  
};